import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import TrackingSetup from './components/TrackingSetup';
import UserJourney from './components/UserJourney';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import './App.css';

function App() {
  return (
    <AnalyticsProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/setup" element={<TrackingSetup />} />
            <Route path="/user/:userId" element={<UserJourney />} />
          </Routes>
        </div>
      </Router>
    </AnalyticsProvider>
  );
}

export default App;